import { Controller } from '@hotwired/stimulus'

// Tap-to-rank ballots. First tap ranks an option 1, the next 2, and so on.
// Tapping a ranked option removes it and compacts higher ranks down.
// Ranked options move to the top of the list in rank order; unranked ones
// keep their original order below. Partial ballots are allowed — submit
// enables once at least one option is ranked.
export default class extends Controller {
  static targets = ['option', 'submit', 'list']

  connect() {
    this.originalOrder = [...this.optionTargets]
    this.refresh()
  }

  toggle(event) {
    const input = this.inputFor(event.currentTarget)
    if (input.value) {
      this.removeRank(parseInt(input.value, 10), input)
    } else {
      input.value = this.rankedCount() + 1
    }
    this.refresh()
  }

  reset() {
    this.optionTargets.forEach((option) => (this.inputFor(option).value = ''))
    this.refresh()
  }

  removeRank(removed, removedInput) {
    removedInput.value = ''
    this.optionTargets.forEach((option) => {
      const input = this.inputFor(option)
      const rank = parseInt(input.value, 10)
      if (rank > removed) input.value = rank - 1
    })
  }

  rankedCount() {
    return this.optionTargets.filter((option) => this.inputFor(option).value).length
  }

  refresh() {
    this.optionTargets.forEach((option) => {
      const value = this.inputFor(option).value
      const badge = option.querySelector('[data-rank-badge]')
      badge.textContent = value || '\u00A0'
      badge.classList.toggle('bg-primary', !!value)
      badge.classList.toggle('text-white', !!value)
      badge.classList.toggle('bg-secondary-subtle', !value)
      badge.classList.toggle('text-dark', !value)
      option.classList.toggle('border-primary', !!value)
    })
    this.submitTarget.disabled = this.rankedCount() === 0
    this.reorder()
  }

  reorder() {
    const sorted = [...this.optionTargets].sort((a, b) => {
      const rankA = parseInt(this.inputFor(a).value, 10) || Infinity
      const rankB = parseInt(this.inputFor(b).value, 10) || Infinity
      if (rankA !== rankB) return rankA - rankB
      return this.originalOrder.indexOf(a) - this.originalOrder.indexOf(b)
    })
    sorted.forEach((option) => this.listTarget.appendChild(option))
  }

  inputFor(option) {
    return option.querySelector('input[type=hidden]')
  }
}
